import React, { Component } from "react";
import { Link } from "react-router-dom";
import Chart from "react-apexcharts";
import Header from "../../components/Header/Header";
import SideBar from "../../components/SideBar/AdminSideBar";
import Footer from "../../components/Footer/Footer";

class ChartJs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: {
        chart: {
          id: "basic-bar",
        },
        xaxis: {
          categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998],
        },
      },
      series: [
        {
          name: "series-1",
          data: [30, 40, 45, 50, 49, 60, 70, 91],
        },
      ],
    };
    this.state1 = {
      options: {
        chart: {
          id: "basic-bar",
        },
        xaxis: {
          categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998],
        },
      },
      series: [
        {
          name: "series-1",
          data: [30, 40, 45, 50, 49, 60, 70, 91],
          color: "#5C42C4",
        },
      ],
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          stops: [0, 90, 100],
        },
      },
    };
    this.state2 = {
      options: {
        chart: {
          id: "basic-bar",
        },
        xaxis: {
          categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998],
        },
      },
      series: [
        {
          name: "series-1",
          data: [30, 40, 45, 50, 49, 60, 70, 91],
          color: "#4F9EEB",
        },
      ],
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          stops: [0, 90, 100],
        },
      },
    };
    this.state3 = {
      series: [
        {
          data: [580, 690, 1100, 1200, 1380, 430, 580, 690, 1100, 1200, 1380],
        },
      ],
      options: {
        chart: {
          type: "bar",
          height: 350,
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: [
            "South Korea",
            "Canada",
            "United Kingdom",
            "Netherlands",
            "Italy",
            "France",
            "Japan",
            "United States",
            "China",
            "Germany",
          ],
        },
      },
    };
    this.state4 = {
      series: [
        {
          name: "Website Blog",
          type: "column",
          data: [440, 505, 414, 671, 227, 413, 201, 352, 752, 320, 257, 160],
        },
        {
          name: "Social Media",
          type: "line",
          data: [23, 42, 35, 27, 43, 22, 17, 31, 22, 22, 12, 16],
        },
      ],
      options: {
        chart: {
          height: 350,
          type: "line",
        },
        stroke: {
          width: [0, 4],
        },
        title: {
          text: "Traffic Sources",
        },
        dataLabels: {
          enabled: true,
          enabledOnSeries: [1],
        },
        labels: [
          "01 Jan 2001",
          "02 Jan 2001",
          "03 Jan 2001",
          "04 Jan 2001",
          "05 Jan 2001",
          "06 Jan 2001",
          "07 Jan 2001",
          "08 Jan 2001",
          "09 Jan 2001",
          "10 Jan 2001",
          "11 Jan 2001",
          "12 Jan 2001",
        ],
        xaxis: {
          type: "datetime",
        },
        yaxis: [
          {
            title: {
              text: "Website Blog",
            },
          },
          {
            opposite: true,
            title: {
              text: "Social Media",
            },
          },
        ],
      },
    };
    this.state5 = {
      series: [
        {
          name: "Desktops",
          data: [10, 41, 35, 51, 49, 62, 69, 91, 148],
          color: "#664DC9",
        },
      ],
      options: {
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },
        title: {
          text: "Product Trends by Month",
          align: "left",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
          ],
        },
      },
    };
    this.state6 = {
      series: [44, 55, 41, 17, 15],
      options: {
        chart: {
          type: "donut",
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
    };
    this.state7 = {
      series: [44, 55, 67, 83],
      options: {
        chart: {
          height: 350,
          type: "radialBar",
        },
        plotOptions: {
          radialBar: {
            dataLabels: {
              name: {
                fontSize: "22px",
              },
              value: {
                fontSize: "16px",
              },
              total: {
                show: true,
                label: "Total",
                formatter: function (w) {
                  return 249;
                },
              },
            },
          },
        },
        labels: ["Apples", "Oranges", "Bananas", "Berries"],
      },
    };
    this.state8 = {
      series: [
        {
          name: "series1",
          data: [31, 40, 28, 51, 42, 109, 100],
          color: "#44C4FA",
        },
        {
          name: "series2",
          data: [11, 32, 45, 32, 34, 52, 41],
          color: "#664DC9",
        },
      ],
      options: {
        chart: {
          height: 350,
          type: "area",
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        xaxis: {
          type: "datetime",
          categories: [
            "2018-09-19T00:00:00.000Z",
            "2018-09-19T01:30:00.000Z",
            "2018-09-19T02:30:00.000Z",
            "2018-09-19T03:30:00.000Z",
            "2018-09-19T04:30:00.000Z",
            "2018-09-19T05:30:00.000Z",
            "2018-09-19T06:30:00.000Z",
          ],
        },
        tooltip: {
          x: {
            format: "dd/MM/yy HH:mm",
          },
        },
      },
    };
  }

  render() {
    return (
      <>
        <div className="main-wrapper">
          {/* Header */}
          <Header />

          {/* Sidebar */}
          <SideBar />


          {/* Page Wrapper */}
          <div className="page-wrapper cardhead">
            <div className="content">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col">
                    <h3 className="page-title">Chartjs</h3>
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/admindashboard">Dashboard</Link>
                      </li>
                      <li className="breadcrumb-item active">Components</li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="row">
                {/* Chart */}
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title">Bar Chart</div>
                    </div>
                    <div className="card-body">
                      <Chart
                        options={this.state.options}
                        series={this.state.series}
                        type="bar"
                      />
                    </div>
                  </div>
                </div>
                {/* /Chart */}
                {/* Chart */}
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title">Transparency </div>
                    </div>
                    <div className="card-body">
                      <Chart
                        options={this.state1.options}
                        series={this.state1.series}
                        type="bar"
                      />
                    </div>
                  </div>
                </div>
                {/* /Chart */}
                {/* Chart */}
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title">Gradient Bar Chart</div>
                    </div>
                    <div className="card-body">
                      <div>
                        <Chart
                          options={this.state2.options}
                          series={this.state2.series}
                          type="bar"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Chart */}
                {/* Chart */}
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title">Horizontal Bar Chart</div>
                    </div>
                    <div className="card-body">
                      <div className="chartjs-wrapper-demo">
                        <Chart
                          options={this.state3.options}
                          series={this.state3.series}
                          type="bar"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Chart */}
                {/* Chart */}
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title">
                        Vertical Stacked Bar Chart
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="chartjs-wrapper-demo">
                        <Chart
                          options={this.state4.options}
                          series={this.state4.series}
                          type="line"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Chart */}
                {/* Chart */}
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title">Line Chart</div>
                    </div>
                    <div className="card-body">
                      <div className="chartjs-wrapper-demo">
                        <Chart
                          options={this.state5.options}
                          series={this.state5.series}
                          type="line"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Chart */}
                {/* Chart */}
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title">Donut Chart</div>
                    </div>
                    <div className="card-body">
                      <div className="chartjs-wrapper-demo">
                        <Chart
                          options={this.state6.options}
                          series={this.state6.series}
                          type="donut"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Chart */}
                {/* Chart */}
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title">Pie Chart</div>
                    </div>
                    <div className="card-body">
                      <div className="chartjs-wrapper-demo">
                        <Chart
                          options={this.state7.options}
                          series={this.state7.series}
                          type="radialBar"
                          height={350}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Chart */}
                {/* Chart */}
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title">Area Chart</div>
                    </div>
                    <div className="card-body">
                      <div className="chartjs-wrapper-demo">
                        <Chart
                          options={this.state8.options}
                          series={this.state8.series}
                          type="area"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Chart */}
              </div>
            </div>
            {/* Footer */}
            <Footer />
          </div>
        </div>
        {/* /Main Wrapper */}
      </>
    );
  }
}

export default ChartJs;
